import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Domain } from "../domains.interface";
import { DomainsService } from "../domains.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { EditDomainRequest } from "../domains.interface";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../shared/error-state-matcher";

@Component({
  selector: "app-domains-edit-dialog",
  templateUrl: "./domains-edit-dialog.component.html",
  styleUrls: ["./domains-edit-dialog.component.scss"],
  standalone: false,
})
export class DomainsEditDialogComponent {
  public sendingRequest = false;
  public form: FormGroup;
  public isEditMode: boolean;
  public errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  constructor(
    private service: DomainsService,
    public dialogRef: MatDialogRef<DomainsEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Domain,
  ) {
    this.isEditMode = !!(data && data.domain);
    this.fillInitialForm();
  }

  fillInitialForm = () => {
    this.form = new FormGroup({
      googleAdminEmail: new FormControl(this.data.googleAdminEmail || "", [
        (c) => Validators.required(c),
        (c) => Validators.email(c),
      ]),
    });
  };

  submit = () => {
    this.errorStateMatcher.submitAttempted = true;
    if (this.form.invalid) {
      return;
    }
    this.sendingRequest = true;
    const request: EditDomainRequest = {
      googleAdminEmail: (this.form.value as { googleAdminEmail: string })
        .googleAdminEmail,
    };

    this.service.updateDomain(this.data.domain, request).subscribe(
      () => this.close(request),
      () => {
        this.sendingRequest = false;
      },
    );
  };

  close = (response: EditDomainRequest | undefined) =>
    this.dialogRef.close(response);
}
